import React from "react";
import Tags from "components/common/form/Tags";

export default function TagSelect({ label, name, options, loading }) {
  return <Tags label={label} name={name} options={options} loading={loading} />;
}
